module.exports = __webpack_public_path__ + "media/images/front/treatment_support/img_appeal-acc7179110ea6a16cf8aa784334ea941.png";